import { render } from "./MobileNavIcon.vue?vue&type=template&id=28e21334&scoped=true"
import script from "./MobileNavIcon.vue?vue&type=script&lang=js"
export * from "./MobileNavIcon.vue?vue&type=script&lang=js"

import "./MobileNavIcon.vue?vue&type=style&index=0&id=28e21334&scoped=true&lang=css"

import exportComponent from "/vercel/path0/shinai/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28e21334"]])

export default __exports__